/**
 * Web-specific Encryption Utilities
 * This file provides the same interface as the mobile EncryptionUtils
 * but uses Web Crypto API instead of React Native crypto libraries
 */

import { encryptRequest, decryptResponse } from '../utils/securityUtils';

/**
 * Encrypt data for sending to server
 * Web version using Web Crypto API
 * @param {Object} data - Data to encrypt
 * @returns {Promise<Object>} - { encrypted: true, payload: "iv.authTag.encryptedData" }
 */
export const encryptData = async (data) => {
    return await encryptRequest(data);
};

/**
 * Decrypt data from server
 * Web version using Web Crypto API
 * @param {Object} encryptedResponse - { encrypted: true, payload: string }
 * @returns {Promise<Object>} - Decrypted data
 */
export const decryptData = async (encryptedResponse) => {
    return await decryptResponse(encryptedResponse);
};

export default {
    encryptData,
    decryptData
};
